import * as React from 'react'
import { ReactElement } from 'react'
import Card from '../../../components/Card'
import { CommandBarButton, Stack, StackItem } from '@fluentui/react'
import ReferenceField from '../ReferenceField'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../config/fileConfig'
import { useHistory } from 'react-router-dom'
import FormikTextField from '../../../components/Formik/TextField/FormikTextField'
import useViewport, { Viewport } from '../../../hooks/useViewport'
import { FileFormType } from './FileForm'
import { useTranslation } from 'react-i18next'

interface HeaderCardProps {
    id?: string
    formType?: FileFormType
}

export default function HeaderCard(props: HeaderCardProps): ReactElement {
    const history = useHistory()
    const { t: translate } = useTranslation()

    const { isViewport } = useViewport()
    const { errors, values, handleChange, handleBlur, dirty, submitForm, isSubmitting } =
        useFormikContext<FileMutationDto>()
    const context = useFormikContext<FileMutationDto>()

    return (
        <Card>
            <Stack horizontal={isViewport('>=', Viewport.Large)} tokens={{ childrenGap: 'm', maxWidth: '100%' }}>
                <Stack grow tokens={{ childrenGap: 's2' }}>
                    <Stack
                        horizontal={isViewport('>=', Viewport.XL)}
                        tokens={{ childrenGap: isViewport('>=', Viewport.XL) ? 'm' : 's2' }}
                    >
                        <StackItem grow={1}>
                            <ReferenceField
                                label={translate('file.edit.form.header.reference')}
                                value={values.reference}
                                errorMessage={errors?.reference}
                                onChange={handleChange('reference')}
                                onBlur={handleBlur('reference')}
                                required
                            />
                        </StackItem>
                        <StackItem grow={4}>
                            <FormikTextField
                                context={context}
                                label={translate('file.edit.form.header.name')}
                                fieldName="name"
                                textFieldProps={{ required: true }}
                            />
                        </StackItem>
                    </Stack>
                    <StackItem>
                        <FormikTextField
                            context={context}
                            label={translate('file.edit.form.header.description')}
                            fieldName="description"
                            textFieldProps={{ multiline: true, rows: 3, autoAdjustHeight: true }}
                        />
                    </StackItem>
                </Stack>
                <Stack
                    horizontal={isViewport('<', Viewport.Large)}
                    reversed={isViewport('<', Viewport.Large)}
                    tokens={{ childrenGap: 0 }}
                >
                    <CommandBarButton
                        text={translate('action.save')}
                        iconProps={{ iconName: 'SaveAndClose' }}
                        styles={{ root: { height: '44px' } }}
                        disabled={isSubmitting}
                        onClick={submitForm}
                    />
                    <StackItem grow>
                        <span />
                    </StackItem>
                    <CommandBarButton
                        text={dirty ? translate('action.cancel') : translate('action.back')}
                        iconProps={{ iconName: dirty ? 'Cancel' : 'Back' }}
                        styles={{ root: { height: '44px' } }}
                        disabled={isSubmitting}
                        onClick={() =>
                            history.push(props.formType === FileFormType.Add ? '/file' : `/file/${props.id}`)
                        }
                    />
                </Stack>
            </Stack>
        </Card>
    )
}
